import i18n from '@/plugins/i18n';
import { CAPABILITY_LOG, CAPABILITY_ANALYTICS } from '@/utils/constants';

export const colors = [
  '#FF7B7B',
  '#FFC1C1',
  '#FF4C0A',
  '#FF7C41',
  '#F59600',
  '#FFC260',
  '#FFD800',
  '#FFFF53',
  '#FDFCAC',
  '#FFFFFF',
  '#FF0080',
  '#F54AA0',
  '#FF96CB',
  '#FF0A0A',
  '#FF4A4A',
  '#e54242',
  '#cc3b3b',
  '#b23333',
  '#992c2c',
  '#7f2525',
  '#661d1d',
  '#4c1616',
  '#330e0e',
  '#190707',
  '#000000',
];

export const getColor = (index) => {
  if (index >= colors.length || index < 0)
    index = Number.parseInt(colors.length * Math.random());
  return colors[index];
};

export function handleZoomIn() {
  // Find minMax for x

  try {
    if (this.$refs.chart.chart.w.globals.minX)
      this.minX = this.$refs.chart.chart.w.globals.minX;
    if (this.$refs.chart.chart.w.globals.maxX)
      this.maxX = this.$refs.chart.chart.w.globals.maxX;
  } catch (error) {
    // Todo: Handle error
  }

  if (typeof this.minX === 'undefined' && typeof this.maxX === 'undefined') {
    this.handleReset();
  }
  if (this.maxX - this.minX > 2) {
    const centerX = (this.minX + this.maxX) / 2;
    let newMinX = (this.minX + centerX) / 2;
    let newMaxX = (this.maxX + centerX) / 2;
    const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
    this.minX = newMinXMaxX.minX;
    this.maxX = newMinXMaxX.maxX;
    this.$refs.chart.zoomX(this.minX, this.maxX);
  }
}

export function _getNewMinXMaxX(newMinX, newMaxX) {
  return {
    minX: Math.floor(newMinX),
    maxX: Math.floor(newMaxX),
  };
}

export function handleReset() {
  this.$refs.chart.zoomX();
  this.minX = 1;
  this.maxX = this.intervalTime.length;
}

export function updateMinMax(xaxis) {
  this.minX = xaxis.min;
  this.maxX = xaxis.max;
}

export function handleZoomOut() {
  //Find minMax for x
  // This checks if min & max are undefined and resets them

  try {
    if (this.$refs.chart.chart.w.globals.minX)
      this.minX = this.$refs.chart.chart.w.globals.minX;
    if (this.$refs.chart.chart.w.globals.maxX)
      this.maxX = this.$refs.chart.chart.w.globals.maxX;
  } catch (error) {
    // Todo: Handle error
  }

  if (typeof this.minX === 'undefined' && typeof this.maxX === 'undefined') {
    this.handleReset();
  }
  if (this.minX > 0 && this.maxX - this.minX >= 1) {
    const centerX = (this.minX + this.maxX) / 2;
    let newMinX = this.minX - (centerX - this.minX);
    let newMaxX = this.maxX - (centerX - this.maxX);
    const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
    this.minX = newMinXMaxX.minX;
    this.maxX = newMinXMaxX.maxX;
    this.$refs.chart.zoomX(this.minX, this.maxX);
  }
}

export function getUTCMonthName(
  monthOffset,
  fullMonthName = false,
  includeYear = false,
) {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  let targetMonth = (currentMonth + monthOffset + 12) % 12;
  let targetYear = currentYear;

  if (targetMonth > currentMonth) {
    targetYear -= 1;
  }
  const monthNames = [
    i18n.global.t('usage.january'),
    i18n.global.t('usage.february'),
    i18n.global.t('usage.march'),
    i18n.global.t('usage.april'),
    i18n.global.t('usage.may'),
    i18n.global.t('usage.june'),
    i18n.global.t('usage.july'),
    i18n.global.t('usage.august'),
    i18n.global.t('usage.september'),
    i18n.global.t('usage.october'),
    i18n.global.t('usage.november'),
    i18n.global.t('usage.december'),
  ];
  const monthName = monthNames[targetMonth];
  const year = includeYear ? ` ${targetYear}` : '';
  return fullMonthName
    ? `${monthName}${year}`
    : `${monthName.slice(0, 3)}${year}`;
}

export const cusGraphCapabilityLabelMapper = {
  [CAPABILITY_LOG]: 'LM',
  [CAPABILITY_ANALYTICS]: 'ANLYT',
};
